import { combineReducers } from 'redux';
import Settings from './Settings';
import { reducer as formReducers } from 'redux-form';

export default combineReducers({
    settings: Settings,
    form: formReducers
});
